var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:(_vm.type + "-table")},_vm._l((_vm.$store.getters.getFilteredList),function(item,index){return _c((_vm.type + "-card"),{key:index,tag:"component",attrs:{"card":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }